"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _profile = require("@widget/profile");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["onClick"];

function Dropdown(_ref) {
  var onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var dispatch = (0, _reactRedux.useDispatch)();
  var navigate = (0, _reactRouterDom.useNavigate)();
  var iconClassName = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-logout');
  }, []);

  function handleLogout() {
    return _handleLogout.apply(this, arguments);
  }

  function _handleLogout() {
    _handleLogout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch((0, _profile.signOut)());

            case 2:
              navigate(process.env['PUBLIC_URL'] + '/sign-in');

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleLogout.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-locator": props['data-locator'] + '.sign-out',
    className: _defaultModule["default"]['wrapper'],
    title: 'Выйти из кабинета',
    onClick: function onClick() {
      return handleLogout();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['logo']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClassName,
    "data-locator": props['data-locator'] + '.sign-out.icon'
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['label'],
    "data-locator": props['data-locator'] + '.sign-out.title'
  }, "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0430"));
}

var _default = /*#__PURE__*/_react["default"].memo(Dropdown);

exports["default"] = _default;